import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/krystal-purple.svg'
import _imports_1 from '../../../assets/images/krystal-purple.svg'
import _imports_2 from '@/assets/images/close.svg'


const _withScopeId = n => (_pushScopeId("data-v-41372883"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "top_content md:!tw-mt-0" }
const _hoisted_2 = {
  key: 0,
  class: "timeline__wrapper push-changes testing-start md:!tw-h-[unset]"
}
const _hoisted_3 = { class: "timeline__left" }
const _hoisted_4 = {
  key: 0,
  class: "routine__timeline"
}
const _hoisted_5 = { class: "" }
const _hoisted_6 = { class: "property_badge" }
const _hoisted_7 = { class: "notification" }
const _hoisted_8 = { class: "property_badge_text" }
const _hoisted_9 = { class: "main_titlesection md:!tw-mt-[2px]" }
const _hoisted_10 = {
  key: 0,
  class: "md:!tw-text-[18px]"
}
const _hoisted_11 = {
  key: 1,
  class: "md:!tw-text-[18px]"
}
const _hoisted_12 = { class: "project-steps-content" }
const _hoisted_13 = { class: "project-service-list third_step routine__timeline__step" }
const _hoisted_14 = { class: "project-service-list-content" }
const _hoisted_15 = { class: "project-service-list-card" }
const _hoisted_16 = { class: "project-service-item__text" }
const _hoisted_17 = {
  key: 0,
  class: "editor__wrapper"
}
const _hoisted_18 = { class: "property_badge" }
const _hoisted_19 = { class: "notification" }
const _hoisted_20 = { class: "property_badge_text" }
const _hoisted_21 = { class: "main_titlesection md:!tw-mt-[2px]" }
const _hoisted_22 = { class: "md:!tw-text-[18px]" }
const _hoisted_23 = { class: "text__editor tw-pt-4" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_25 = [
  _hoisted_24
]
const _hoisted_26 = { class: "custom_editor" }
const _hoisted_27 = { class: "gemini-model-wrapper" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1))
const _hoisted_29 = {
  key: 1,
  class: "attachment__wrapper"
}
const _hoisted_30 = { class: "property_badge" }
const _hoisted_31 = { class: "notification" }
const _hoisted_32 = { class: "property_badge_text" }
const _hoisted_33 = { class: "main_titlesection md:!tw-mt-[2px]" }
const _hoisted_34 = { class: "md:!tw-text-[18px]" }
const _hoisted_35 = { class: "attachment__wrapper__upload" }
const _hoisted_36 = { class: "left_upload_img md:!tw-mb-0" }
const _hoisted_37 = { class: "upload__area" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, [
  /*#__PURE__*/_createTextVNode(" Upload images and files. "),
  /*#__PURE__*/_createElementVNode("span", null, "(Optional)")
], -1))
const _hoisted_39 = { class: "upload__section md:!tw-h-[100px]" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "tw-hidden" }, " Attachments such as images, design ideas and documents help better understand the project and provide increasingly accurate estimates. ", -1))
const _hoisted_41 = { class: "uploade-wrapper custom-file-upload !tw-h-[250px] md:!tw-h-full" }
const _hoisted_42 = {
  key: 1,
  class: "error_msg"
}
const _hoisted_43 = { class: "section_wrapper timeline__right" }
const _hoisted_44 = { class: "tab__area__right__block" }
const _hoisted_45 = {
  key: 0,
  class: "timeline__right__footer"
}
const _hoisted_46 = { class: "yellow-text" }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content" }, [
  /*#__PURE__*/_createElementVNode("h4", { class: "title" }, "Project Overview")
], -1))
const _hoisted_48 = { class: "tab__area__price" }
const _hoisted_49 = { key: 0 }
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tab__area__item" }, "Project Name", -1))
const _hoisted_51 = { class: "tab__area__item__price yellow-text" }
const _hoisted_52 = { class: "yellow-text" }
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tab__area__item" }, "Job Type", -1))
const _hoisted_54 = { class: "tab__area__item__price yellow-text" }
const _hoisted_55 = { class: "yellow-text" }
const _hoisted_56 = { key: 1 }
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tab__area__item" }, "Preferred Start", -1))
const _hoisted_58 = { class: "tab__area__item__price yellow-text" }
const _hoisted_59 = { class: "yellow-text" }
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "subtitle" }, "Property Information", -1))
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tab__area__item" }, "Properties", -1))
const _hoisted_62 = { class: "tab__area__item__price yellow-text" }
const _hoisted_63 = { class: "yellow-text" }
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tab__area__item" }, "Property Address", -1))
const _hoisted_65 = { class: "tab__area__sub__items" }
const _hoisted_66 = { class: "tab__area__item__price yellow-text" }
const _hoisted_67 = { class: "yellow-text" }
const _hoisted_68 = {
  key: 2,
  id: "view-more-property"
}
const _hoisted_69 = { class: "popup__content" }
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, [
  /*#__PURE__*/_createElementVNode("h5", null, "Properties Addresses"),
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_2,
    alt: ""
  })
], -1))
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tab__area__item" }, "Property Address", -1))
const _hoisted_72 = { class: "tab__area__sub__items" }
const _hoisted_73 = { class: "tab__area__item__price yellow-text" }
const _hoisted_74 = { class: "yellow-text" }
const _hoisted_75 = {
  key: 1,
  class: "selected-info"
}
const _hoisted_76 = { key: 2 }
const _hoisted_77 = { class: "selected-info preview-project-btn" }
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " OR  ", -1))
const _hoisted_79 = { key: 2 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_quillEditor = _resolveComponent("quillEditor")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_file_input = _resolveComponent("v-file-input")!
  const _component_v_img = _resolveComponent("v-img")!
  const _component_ProjectAttachmentListComponent = _resolveComponent("ProjectAttachmentListComponent")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_InviteTeamMember = _resolveComponent("InviteTeamMember")!
  const _component_v_stepper_item = _resolveComponent("v-stepper-item")!
  const _component_v_stepper_header = _resolveComponent("v-stepper-header")!
  const _component_v_stepper = _resolveComponent("v-stepper")!
  const _component_SiteVisitModel = _resolveComponent("SiteVisitModel")!
  const _component_PostProjectLoadingModal = _resolveComponent("PostProjectLoadingModal")!
  const _component_GeminiModelForMobileView = _resolveComponent("GeminiModelForMobileView")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_v_btn, {
        variant: "text",
        "aria-label": "Refresh",
        class: "button button-transparent back_btn",
        "prepend-icon": "mdi-chevron-left",
        onClick: $setup.onClickBackButton
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString($setup.getBackButtonLabel), 1)
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["step__third md:!tw-gap-4 md:!tw-h-[calc(100%-3rem)] property-select-start", { 'project-specifics-box': $setup.currentSelectedTab.id === 4 }])
    }, [
      (!$setup.isShowProjectReview)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", null, [
                (
              [
                $setup.ProjectTypesEnum.STANDARD,
                $setup.ProjectTypesEnum.ROUTINE,
                $setup.ProjectTypesEnum.VIDEO_CONSULTATION,
              ].includes($setup.userProjectType) && $setup.currentSelectedTab.id === 3
            )
                  ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                      _createElementVNode("div", _hoisted_5, [
                        _createElementVNode("div", _hoisted_6, [
                          _createElementVNode("div", _hoisted_7, _toDisplayString($setup.currentSelectedTab.id), 1),
                          _createElementVNode("div", _hoisted_8, _toDisplayString($setup.currentSelectedTab.name), 1)
                        ]),
                        _createElementVNode("div", _hoisted_9, [
                          (
                    [
                      $setup.ProjectTypesEnum.STANDARD,
                      $setup.ProjectTypesEnum.VIDEO_CONSULTATION,
                    ].includes($setup.userProjectType)
                  )
                            ? (_openBlock(), _createElementBlock("h3", _hoisted_10, " When are you looking to start this project: "))
                            : (_openBlock(), _createElementBlock("h3", _hoisted_11, " How often do you need this project to occur? "))
                        ]),
                        _createElementVNode("div", _hoisted_12, [
                          _createElementVNode("div", _hoisted_13, [
                            _createElementVNode("div", _hoisted_14, [
                              _createElementVNode("div", _hoisted_15, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.getProjectTimelineList, (item) => {
                                  return (_openBlock(), _createBlock(_component_v_card, {
                                    class: _normalizeClass(["project-service-item", { selected: item.selected }]),
                                    key: item.id,
                                    onClick: ($event: any) => ($setup.toggleSelectionType(item.name))
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("div", _hoisted_16, [
                                        _createElementVNode("h6", null, _toDisplayString(item.name), 1)
                                      ])
                                    ]),
                                    _: 2
                                  }, 1032, ["class", "onClick"]))
                                }), 128))
                              ])
                            ])
                          ])
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              ($setup.isShowJobSpecifics && $setup.currentSelectedTab.id == 4)
                ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                    _createElementVNode("div", _hoisted_18, [
                      _createElementVNode("div", _hoisted_19, _toDisplayString($setup.currentSelectedTab.id), 1),
                      _createElementVNode("div", _hoisted_20, _toDisplayString($setup.currentSelectedTab.name), 1)
                    ]),
                    _createElementVNode("div", _hoisted_21, [
                      _createElementVNode("h3", _hoisted_22, _toDisplayString($setup.currentSelectedTab.title), 1)
                    ]),
                    _createElementVNode("div", _hoisted_23, [
                      _createVNode(_component_v_text_field, {
                        class: "projecttitle_select md:!tw-text-[16px] md:!tw-pt-0",
                        placeholder: "Project Title/ Name",
                        modelValue: $setup.projectTitle,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.projectTitle) = $event)),
                        variant: "underlined",
                        density: "compact",
                        rules: $setup.validation.projectTitle
                      }, {
                        "append-inner": _withCtx(() => [
                          _createElementVNode("div", {
                            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.onClickTitleKrystalIcon && $setup.onClickTitleKrystalIcon(...args)))
                          }, _hoisted_25)
                        ]),
                        _: 1
                      }, 8, ["modelValue", "rules"]),
                      _createElementVNode("div", _hoisted_26, [
                        _withDirectives(_createElementVNode("div", {
                          id: "quill-cursor-box-mobile",
                          class: "temp-box mobile__cursor",
                          onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.showGeminiModelForMobile = !$setup.showGeminiModelForMobile))
                        }, null, 512), [
                          [_vShow, $setup.showButtonForGeminiModel]
                        ]),
                        _createVNode(_component_quillEditor, {
                          value: $setup.state.content,
                          "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => (($setup.state.content) = $event)),
                          options: $setup.state.editorOption,
                          disabled: $setup.state.disabled,
                          onChange: _cache[4] || (_cache[4] = ($event: any) => ($setup.onEditorChange($event))),
                          onFocus: _cache[5] || (_cache[5] = ($event: any) => ($setup.onEditorFocus($event))),
                          onReady: $setup.onEditorReady,
                          class: "editor_ql"
                        }, null, 8, ["value", "options", "disabled", "onReady"]),
                        _createElementVNode("div", _hoisted_27, [
                          (!$setup.isMobileView)
                            ? (_openBlock(), _createBlock(_component_v_btn, {
                                key: 0,
                                onClick: _cache[6] || (_cache[6] = ($event: any) => ($setup.showGeminiModelForMobile = !$setup.showGeminiModelForMobile)),
                                class: "button button-purple krystal-trigger desktop-model",
                                "append-icon": "mdi-chevron-right"
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_28,
                                  _createTextVNode(" KRYSTAl ")
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              ($setup.isShowAttachments && $setup.currentSelectedTab.id == 5)
                ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                    _createElementVNode("div", _hoisted_30, [
                      _createElementVNode("div", _hoisted_31, _toDisplayString($setup.currentSelectedTab.id), 1),
                      _createElementVNode("div", _hoisted_32, _toDisplayString($setup.currentSelectedTab.name), 1)
                    ]),
                    _createElementVNode("div", _hoisted_33, [
                      _createElementVNode("h3", _hoisted_34, _toDisplayString($setup.currentSelectedTab.title), 1)
                    ]),
                    _createElementVNode("div", _hoisted_35, [
                      _createElementVNode("div", _hoisted_36, [
                        _createElementVNode("div", _hoisted_37, [
                          _hoisted_38,
                          _createElementVNode("div", _hoisted_39, [
                            _hoisted_40,
                            _createElementVNode("div", _hoisted_41, [
                              _createVNode(_component_v_file_input, {
                                class: _normalizeClass(["upload_file", { 'added-img': $setup.imageUrl }]),
                                label: "Drag and drop documents or Browse",
                                accept: "image/png, image/jpeg, image/jpg",
                                variant: "solo-filled",
                                modelValue: $setup.selectedFile,
                                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (($setup.selectedFile) = $event)),
                                onChange: $setup.onFileChange,
                                "onClick:clear": $setup.clearImageUrl,
                                multiple: ""
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_icon, {
                                    icon: "mdi mdi-file-image-box",
                                    class: "label-img"
                                  })
                                ]),
                                _: 1
                              }, 8, ["modelValue", "class", "onChange", "onClick:clear"]),
                              ($setup.imageUrl)
                                ? (_openBlock(), _createBlock(_component_v_img, {
                                    key: 0,
                                    class: "uploaded-img",
                                    width: 200,
                                    "aspect-ratio": "16/9",
                                    cover: "",
                                    src: $setup.imageUrl
                                  }, null, 8, ["src"]))
                                : _createCommentVNode("", true),
                              ($setup.errorMessage)
                                ? (_openBlock(), _createElementBlock("p", _hoisted_42, _toDisplayString($setup.errorMessage), 1))
                                : _createCommentVNode("", true)
                            ])
                          ])
                        ])
                      ]),
                      ($setup.attachmentDataList?.length)
                        ? (_openBlock(), _createBlock(_component_ProjectAttachmentListComponent, {
                            key: 0,
                            class: "preview-img",
                            attachmentList: $setup.attachmentDataList,
                            properties: $setup.userSelectedProperties,
                            isPreviewFlexCol: false,
                            onOnDelete: $setup.clearImageUrl
                          }, null, 8, ["attachmentList", "properties", "onOnDelete"]))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_43, [
              _createElementVNode("div", _hoisted_44, [
                ($props.workflowType === $setup.PropertyWorkflowTypeEnum.PROPERTY)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                      _createVNode(_component_v_btn, {
                        class: "button button-purple-border",
                        size: "large",
                        block: "",
                        onClick: $setup.onInviteTeamMember
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" invite team member to project ")
                        ]),
                        _: 1
                      }, 8, ["onClick"])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("label", _hoisted_46, [
                  _createTextVNode("Load Project Template "),
                  _createVNode(_component_v_icon, { icon: "mdi-chevron-right" })
                ]),
                _createVNode(_component_v_card, { class: "tab__area__right__block__card third_step" }, {
                  default: _withCtx(() => [
                    _hoisted_47,
                    _createElementVNode("div", _hoisted_48, [
                      _createElementVNode("ul", null, [
                        (![3].includes($setup.currentSelectedTab.id))
                          ? (_openBlock(), _createElementBlock("li", _hoisted_49, [
                              _hoisted_50,
                              _createElementVNode("div", _hoisted_51, [
                                _createElementVNode("p", _hoisted_52, _toDisplayString($setup.projectTitle), 1)
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        _createElementVNode("li", null, [
                          _hoisted_53,
                          _createElementVNode("div", _hoisted_54, [
                            _createElementVNode("p", _hoisted_55, _toDisplayString($setup.userProjectType), 1)
                          ])
                        ]),
                        (
                    [
                      $setup.ProjectTypesEnum.STANDARD,
                      $setup.ProjectTypesEnum.ROUTINE,
                      $setup.ProjectTypesEnum.VIDEO_CONSULTATION,
                    ].includes($setup.userProjectType)
                  )
                          ? (_openBlock(), _createElementBlock("li", _hoisted_56, [
                              _hoisted_57,
                              _createElementVNode("div", _hoisted_58, [
                                _createElementVNode("p", _hoisted_59, _toDisplayString($setup.selectedTimelineType?.name), 1)
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        _hoisted_60,
                        _createElementVNode("li", null, [
                          _hoisted_61,
                          _createElementVNode("div", _hoisted_62, [
                            _createElementVNode("p", _hoisted_63, _toDisplayString($setup.userSelectedProperties?.length), 1)
                          ])
                        ]),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.userSelectedProperties.slice(0, 3), (item, index) => {
                          return (_openBlock(), _createElementBlock("li", { key: index }, [
                            _hoisted_64,
                            _createElementVNode("div", _hoisted_65, [
                              _createElementVNode("div", _hoisted_66, [
                                _createElementVNode("p", _hoisted_67, _toDisplayString(item.address), 1)
                              ])
                            ])
                          ]))
                        }), 128)),
                        ($setup.userSelectedProperties?.length - 3 > 0)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_68, " +" + _toDisplayString($setup.userSelectedProperties?.length - 3) + " More ", 1))
                          : _createCommentVNode("", true),
                        _createVNode(_component_v_menu, {
                          target: "cursor",
                          transition: "slide-y-reverse-transition",
                          activator: "#view-more-property",
                          width: "350px",
                          class: "custom_popup"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_69, [
                              _hoisted_70,
                              _createElementVNode("ul", null, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.userSelectedProperties, (item, index) => {
                                  return (_openBlock(), _createElementBlock("li", { key: index }, [
                                    _hoisted_71,
                                    _createElementVNode("div", _hoisted_72, [
                                      _createElementVNode("div", _hoisted_73, [
                                        _createElementVNode("p", _hoisted_74, _toDisplayString(item.address), 1)
                                      ])
                                    ])
                                  ]))
                                }), 128))
                              ])
                            ])
                          ]),
                          _: 1
                        })
                      ])
                    ])
                  ]),
                  _: 1
                }),
                (!$setup.isShowAttachments)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_75, [
                      _createVNode(_component_v_btn, {
                        "aria-label": "Refresh",
                        class: "button button-orange",
                        onClick: $setup.onClickSideContinueButton,
                        disabled: $setup.isSideContinueBtnDisable
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("continue")
                        ]),
                        _: 1
                      }, 8, ["onClick", "disabled"]),
                      ($setup.currentSelectedTab.id == 4)
                        ? (_openBlock(), _createBlock(_component_v_btn, {
                            key: 0,
                            class: "save-btn",
                            variant: "text",
                            onClick: $setup.saveForDraftProject,
                            loading: $setup.isShowLoadingOnScreen
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(" save project for later ")
                            ]),
                            _: 1
                          }, 8, ["onClick", "loading"]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                ($setup.isShowAttachments && $setup.currentSelectedTab.id == 5)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_76, [
                      _createElementVNode("div", _hoisted_77, [
                        _createVNode(_component_v_btn, {
                          "aria-label": "Refresh",
                          class: "button button-orange",
                          onClick: _cache[8] || (_cache[8] = ($event: any) => ($setup.onClickPostProject(false))),
                          disabled: !$setup.isAttachmentDataValid || $setup.loading,
                          loading: $setup.loading
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("PREVIEW PROJECT")
                          ]),
                          _: 1
                        }, 8, ["disabled", "loading"])
                      ]),
                      ($props.workflowType === $setup.PropertyWorkflowTypeEnum.PROPERTY)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: _normalizeClass(["project-live-btn", {
                'tw-justify-center md:!tw-mb-4': $setup.currentSelectedTab.id === 5,
              }])
                          }, [
                            _hoisted_78,
                            _createVNode(_component_v_btn, {
                              variant: "text",
                              class: _normalizeClass(["save-btn", { disable: !$setup.isAttachmentDataValid }]),
                              disabled: !$setup.isAttachmentDataValid || $setup.loading,
                              onClick: $setup.onClickSiteVisit
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(" Post Project Live ")
                              ]),
                              _: 1
                            }, 8, ["class", "disabled", "onClick"])
                          ], 2))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      ($setup.iShowInviteTeamMemberModal)
        ? (_openBlock(), _createBlock(_component_InviteTeamMember, {
            key: 1,
            onOnCloseModal: $setup.onCloseModal
          }, null, 8, ["onOnCloseModal"]))
        : _createCommentVNode("", true),
      (!$setup.isShowProjectReview)
        ? (_openBlock(), _createBlock(_component_v_stepper, {
            key: 2,
            class: "onboard-stepper",
            modelValue: $setup.currentSelectedTab.id,
            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (($setup.currentSelectedTab.id) = $event))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_stepper_header, { class: "onboard-stepper__header" }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.getStepperList, (step) => {
                    return (_openBlock(), _createBlock(_component_v_stepper_item, {
                      class: _normalizeClass(["onboard-stepper__item", { done: $setup.currentSelectedTab.id > step.id }]),
                      key: step.id,
                      title: step.tab,
                      value: step.id
                    }, null, 8, ["title", "value", "class"]))
                  }), 128))
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"]))
        : _createCommentVNode("", true)
    ], 2),
    ($setup.isShowSiteVisitModal)
      ? (_openBlock(), _createBlock(_component_SiteVisitModel, {
          key: 0,
          returnStatus: true,
          onOnClickBack: $setup.onClickSiteVisit,
          onOnClickPostProject: $setup.onClickPostLiveProject
        }, null, 8, ["onOnClickBack", "onOnClickPostProject"]))
      : _createCommentVNode("", true),
    ($setup.isPostLoadingModal)
      ? (_openBlock(), _createBlock(_component_PostProjectLoadingModal, {
          key: 1,
          switchingText: $setup.switchingText,
          projectPostProgressLoading: $setup.projectPostProgressLoading
        }, null, 8, ["switchingText", "projectPostProgressLoading"]))
      : _createCommentVNode("", true),
    ($setup.showGeminiModelForMobile)
      ? (_openBlock(), _createElementBlock("div", _hoisted_79, [
          _createVNode(_component_GeminiModelForMobileView, {
            onAppendJobDescription: $setup.appendJobDescription,
            onOnClose: $setup.onCloseHandler,
            isTitleKrystalIconClick: $setup.isTitleKrystalIconClick
          }, null, 8, ["onAppendJobDescription", "onOnClose", "isTitleKrystalIconClick"])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}